// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__eNvVL","title":"Hero_title__92z_s","text":"Hero_text__Elp_5","outer":"Hero_outer__brT_0","carouselImage":"Hero_carouselImage__9kgYV"};